import React, { useState, useEffect, memo } from "react";
import currentStatus from "components/current-status.jpg";
import completeStatus from "components/current-status-complete.jpg";
import playingStatus from "components/current-status-playing.jpg";
import completeRecord from "components/current-status-record-complete.jpg";
import currentRecording from "components/current-status-recording.jpg";

const SpeakingInstructions = memo( function SpeakingInstructions({ setNextFlag }) {

	useEffect(() => {
		setNextFlag(true);
	}, []);
	
	return (
		<div className="col-xs-12 successContent mock-resource-text">
			<div className="row w-100">
				<div className="col-lg-12">
					<h4 className="mt-0">Speaking Instructions</h4>
					<h6>Some questions require you to first listen to an audio clip and then record your answer by speaking clearly into the microphone.</h6>
					<div className="row speakingStatus mb-5 mt-4">
						<div className="col-sm-4">
							<p><b>Listening: </b>The Current Status shows how long you have until the audio clip starts.</p>
							<img src={currentStatus} />
						</div>
						<div className="col-sm-6 pl-5">
							<p>A blue bar shows the progress of the audio clip. When it reaches the right hand side the audio, clip will stop playing.</p>
							<div className="row doubleImges">
								<div className="col-sm-6"><img src={completeStatus} /></div>
								<div className="col-sm-6"><img src={playingStatus} /></div>
							</div>
						</div>
					</div>
					<div className="row speakingStatus">
						<div className="col-sm-4">
							<p><b>Speaking: </b>The Current Status shows how long you have until the microphone opens. Start speaking when the status changes to recording.</p>
							<img src={currentStatus} />
						</div>
						<div className="col-sm-6 pl-5">
							<p>You must finish before the progress bar reaches the right hand side. If you remain silent for longer than 3 seconds, the recording will stop. You will not be able to re-record.</p>
							<div className="row doubleImges">
								<div className="col-sm-6"><img src={completeRecord} /></div>
								<div className="col-sm-6"><img src={currentRecording} /></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});

export default SpeakingInstructions;